<template>
  <div>
    <div class="app-reg-notice">
      <div v-if="stepNum==1 || stepNum==2 || stepNum==3" >
        <strong>Duplicate Registration -</strong> 
        <span class="vehicle-type">{{ year }} {{ make }} {{ model !='UNKNOWN' ? model : '' }} {{ plateNumber }} / {{ plateType }}</span> 
      </div>
      <div v-if="stepNum==4">
        <strong>Transaction Cart</strong>
      </div>
      <div v-if="stepNum==5">
        <strong>{{($store.state.guestLogin.totalBill && $store.state.guestLogin.totalBill.totalSumFeeAmount > 0) ? 'Payment information' : 'Contact information'}}</strong>
      </div>
      <div v-if="stepNum==6">
        <strong>Transaction confirmation</strong>
      </div>
    </div>
    <div>
      <SystemAlert/>
    </div>
    <Stepper :step="stepNum"/>
    <template v-if="stepNum=='1'"><GetReady  @getStep="getStep"/></template>
    <template v-if="stepNum=='2'"> <TransactionInfo  @getStep="getStep"/></template>
    <template v-if="stepNum=='3'"><TransactionFee @getStep="getStep" /></template>
    <template v-if="stepNum=='4'"> <TransactionCart @getStep="getStep" /> </template>
    <template v-if="stepNum=='5'"><Payment @getStep="getStep" /></template>
    <template v-if="stepNum=='6'"><Confirmation @getStep="getStep" /></template> 
  </div>
</template>
    
<script>
  import appConfig from '@/app.config';
  import Stepper from '../../components/Stepper.vue';
  import GetReady from './GetReady.vue';
  import TransactionInfo from './TransactionInfo.vue';
  import TransactionFee from './TransactionFee.vue';
  import TransactionCart from '../renewReg/TransactionCart.vue'
  import Payment from '../renewReg/Payment.vue';
  import Confirmation from '../renewReg/Confirmation.vue';
  import { mapGetters, mapActions } from 'vuex';
  import * as COMMONS from '../../store/_commons';
  import SystemAlert from '@/components/SystemAlert'
  
  export default {
    name: 'DuplicateReg',
    page: {
      title: `DuplicateReg | ${appConfig.shortName}`,
      meta: [
        {
          name: 'description',
          content: 'You can duplicate your vehicle registrations'
        }
      ]
    },
    data() {
      return {
        year:  this.$store.state.guestLogin.selectRenewRegistartion.year,
        make: this.$store.state.guestLogin.selectRenewRegistartion.make,
        model: this.$store.state.guestLogin.selectRenewRegistartion.model,
        plateNumber: this.$store.state.guestLogin.selectRenewRegistartion.plateNumber,
        plateType: this.$store.state.guestLogin.selectRenewRegistartion.plateType,
      }
    },
    components: {
      Stepper,
      GetReady,
      TransactionInfo,
      TransactionFee,
      TransactionCart,
      Payment,
      Confirmation,
      SystemAlert
    },

    computed: {
      ...mapGetters({
        renewRegistrationInfo: COMMONS.GUEST_RENEWREGISTRATION_INFO,
      }),

      stepNum() {
        return this.$store.state.guestLogin.step;
      }
    },
    
    methods: {
      ...mapActions({
        // getRenewRegistrationEligibility: COMMONS.GUEST_RENEWREGISTRATION,
        getGuestLogout: COMMONS.GUEST_LOGIN_GET_LOGOUT,
        getDuplicateRegistrationEligibility: COMMONS.GUEST_DUPLICATEREGISTRATION
      }),

      getDuplicateRegistration() {
        this.getDuplicateRegistrationEligibility(this.vehicleRegistrationId);
      },

      getStep(val) {
        console.log(val);
      },

      // getLogout() {
      //   // this.getGuestLogout();
      //   alert('browser-back');
      // },
    },

    mounted() {
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function() {
        history.go(1);
      }
    },

    // beforeDestroy() {
    //   document.removeEventListener("back-button", this.getLogout());  
    // }
  }
</script>

<style scoped lang="scss">
  .app-reg-notice {
    max-width: 100%;
    background: var(--ri-light-blue);
    height: 100%;
    display: flex;
    padding: 1em;
    font-size: 20px;
    margin-bottom: 0px;
    margin-top: 5px;
    padding-left: var(--padding-horizontal);
    padding-right: var(--padding-horizontal);

    @media print {
      @page { size: 11in 8.5in; }
      background-color: var(--print-background);
    }
    .vehicle-type {
      margin-left: 5px;
    }
  }
  @media only screen and (max-width: 796px) {
    .app-reg-notice {
      display: block; 
      margin-top: 5px;
    }
  }
</style>
